module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__tracking-statuses"
    }
  }, [_c('md-content', {
    attrs: {
      "md-theme": "white",
      "loading": _vm.progress
    }
  }, [_c('stock-menu'), _vm._v(" "), _c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.statusesAmount,
      "table-id": "tracking-statuses",
      "tableHeight": "calc(100% - 48px)",
      "showAddButton": false,
      "link": ""
    },
    on: {
      "refresh": _vm.getStatuses
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(scope) {
        return [_c('span', {
          style: ('color: ' + scope.item.color)
        }, [_vm._v(" " + _vm._s(scope.item.name) + " ")])]
      }
    }, {
      key: "code",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s((scope.item.code) ? scope.item.code : 'Не установлен') + " ")])]
      }
    }, {
      key: "tracking_type",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s(scope.item.tracking_type) + " ")])]
      }
    }, {
      key: "confirm_deal",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s((scope.item.confirm_deal && parseInt(scope.item.confirm_deal) === 1) ? 'Да' : 'Нет') + " ")])]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return undefined
      }
    }]),
    model: {
      value: (_vm.tableStatuses),
      callback: function($$v) {
        _vm.tableStatuses = $$v
      },
      expression: "tableStatuses"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54af6540","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/TrackingStatuses.vue
// module id = 1149
// module chunks = 0